// Clevertap parameter constants
// TODO: Abhay change this code later
import { getClevertapPlatform } from 'AccountsUtils'

export const CLEVERTAP_PLATFORM = getClevertapPlatform()
export const CLEVERTAP_EVENT_NAME = 'account'
